import { Fragment } from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import CallResultClassificationsPage from './CallResultClassificationsPage';

const CallResultClassificationsWrapper = () => {
    return (
        <Fragment>
            <PageHeader
                title="Tipos de seguimiento"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Tipos de seguimiento', href: menuRoutes.calls.path + menuRoutes.calls.classifications },
                ]}
            />
            <CallResultClassificationsPage />
        </Fragment>
    );
};

export default CallResultClassificationsWrapper;
